import React, { useState } from "react";
import Upload from "../../Containers/Upload";

const inputClass = "w-full px-3 py-2 rounded bg-gray-600 text-white border border-gray-500 focus:outline-none focus:border-blue-400";

function DynamicForm({ formConfig, isShowUpload, setShowUpload, formData }) {
    let formFiledContent = null

    function onTextChange(e) {
        formConfig.onChange({ [e.target.name]: e.target.value, formName: formConfig.formName })
    }

    switch (formConfig.type) {
        case 'date':
        case 'text':
        case 'password':
            formFiledContent =
                <input type={formConfig.type}
                    className={inputClass}
                    placeholder={formConfig.placeholder}
                    disabled={formConfig.disabled}
                    defaultValue={formConfig.defaultValue}
                    value={formData[formConfig.fieldName]}
                    name={formConfig.fieldName}
                    onChange={onTextChange}
                    readOnly={formConfig.readOnly}
                />
            break;
        case 'select':
        case 'dropDown':
            formFiledContent = <select
                className={inputClass}
                disabled={formConfig.disabled}
                defaultValue={formConfig.defaultValue}
                value={formData[formConfig.fieldName]}
                name={formConfig.fieldName}
                onChange={onTextChange}
            >
                {formConfig.enum.map(item => <option key={item.value}>{item.label}</option>)}
            </select>
            break;

        case 'checkbox':
        case 'radio':
        case 'switch':
            formFiledContent = <input
                type={formConfig.type === 'switch' ? 'checkbox' : formConfig.type}
                className="mr-2"
                disabled={formConfig.disabled}
                defaultValue={formConfig.defaultValue}
                value={formData[formConfig.fieldName]}
                name={formConfig.fieldName}
                onChange={onTextChange}
                readOnly={formConfig.readOnly}
            />
            break;
        case 'file':
            formFiledContent = <Upload
                getFilesPath={onTextChange}
                single={true}
                images={formData[formConfig.fieldName]}
                uploadOnSelect={false}
                capture={true}
                isShowUpload={isShowUpload || true}
                setShowUpload={setShowUpload}
            />
            break;
        default: {
            formFiledContent = null
        }
    }

    return (
        <div className="mb-3" key={formConfig.fieldName}>
            <label className="block text-white mb-1">{formConfig.label}</label>
            {formFiledContent}
            {formConfig.errorText ? <p className="text-error text-sm mt-1">{formConfig.errorText}</p> : null}
        </div>
    );
}

export default DynamicForm;
